type ReliabilityBadgeProps = {
  value: string;
  size?: "sm" | "md";
};

const styles: Record<string, string> = {
  实锤: "bg-primary-500 text-background-50",
  待证实: "bg-accent-400 text-foreground-950",
  追踪中: "bg-secondary-200 text-secondary-900",
};

export default function ReliabilityBadge({ value, size = "sm" }: ReliabilityBadgeProps) {
  const cls = styles[value] ?? "bg-secondary-200 text-secondary-900";
  const sizing = size === "md" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-label font-bold whitespace-nowrap ${cls} ${sizing}`}
    >
      {value === "实锤" && <i className="ri-shield-check-fill text-[11px]" aria-hidden="true" />}
      {value === "待证实" && <i className="ri-question-fill text-[11px]" aria-hidden="true" />}
      {value === "追踪中" && <i className="ri-radar-line text-[11px]" aria-hidden="true" />}
      {value}
    </span>
  );
}